import { just, nothing } from 'maybeasy';
import { useLearningCollection } from '../LearningCollectionContext';
import { EditLearningCollectionResource, LearningCollectionResource } from '../Types';

interface UseReadyBuilder {
  resourceState: LearningCollectionResource | EditLearningCollectionResource;
  handleLearningCollectionNameChange: (value: string) => void;
  handleLearningCollectionInternalNameChange: (value: string) => void;
  handleLearningCollectionDescriptionChange: (value: string) => void;
}

export const useReadyBuilder = (): UseReadyBuilder => {
  const { resourceState, setResourceState } = useLearningCollection();

  const handleLearningCollectionNameChange = (value: string) => {
    const newResourceState = {
      ...resourceState,
      payload: { ...resourceState.payload, name: value },
    };
    setResourceState(newResourceState);
  };

  const handleLearningCollectionInternalNameChange = (value: string) => {
    const newResourceState = {
      ...resourceState,
      payload: {
        ...resourceState.payload,
        internal_name: value ? just<string>(value) : nothing<string>(),
      },
    };
    setResourceState(newResourceState);
  };

  const handleLearningCollectionDescriptionChange = (value: string) => {
    const newResourceState = {
      ...resourceState,
      payload: { ...resourceState.payload, description: value },
    };
    setResourceState(newResourceState);
  };

  return {
    resourceState,
    handleLearningCollectionNameChange,
    handleLearningCollectionInternalNameChange,
    handleLearningCollectionDescriptionChange,
  };
};
